// extracted by mini-css-extract-plugin
export default {"footer":"PublicSiteFooter_footer__n08iJ","container":"PublicSiteFooter_container__yDzt4","brand":"PublicSiteFooter_brand__MOttv","copy":"PublicSiteFooter_copy__nItuN"};